import deepmerge from "common/utils/deepmerge";
import { deleteIn } from "common/utils/objectUtils";
import type { DocMigration } from "../docMigration";

/**
 * Utilities copied from previous versions of the application code
 * for compatibility with Studio Documents on outdated schemas.
 */

export function defaultElevationIdFromTable(elevations: any): string {
  const entries = Object.entries<any>(elevations);
  const defaultEntry = entries.find((x) => x[1]["isDefault"]);
  if (!defaultEntry) {
    return entries[0][0];
  }
  return defaultEntry[0];
}

export function mergeOverridesIntoSystemParam(optionIds: string[], target: any, source?: any, optionsToMerge?: any) {
  if (source) {
    target = deepmerge(target, source, optionsToMerge);
  }

  // remove defaultValues that are no longer valid
  if (!optionIds.includes(target.defaultValue)) {
    target = deleteIn(target, ["defaultValue"]);
  }

  // remove options that are no longer valid
  if (target.paramValues) {
    for (const optionId in target.paramValues) {
      if (!optionIds.includes(optionId)) {
        target = deleteIn(target, ["paramValues", optionId]);
      }
    }
  }

  return target;
}

function elevationStyleParam(elevations: any, prevOptionSet: any) {
  const elevationIds = Object.keys(elevations);

  let optionSet = {
    id: "elevationStyle",
    sortIndex: 0,
    entityType: "PARAM",
    defaultValue: defaultElevationIdFromTable(elevations),
    category: "Elevations",
    name: "Elevation",
    salesCategory: "UNCATEGORIZED",
    paramValues: elevations,
    tags: ["ELEVATION"],
  };

  // Maintain the new elevation names from the table
  const elevationMergeOptions = {
    omit: {
      name: true,
    },
  };

  optionSet = mergeOverridesIntoSystemParam(elevationIds, optionSet, prevOptionSet, elevationMergeOptions);

  return optionSet;
}

export function elevationStyleParams(config: any, prevElevation: any): any {
  return {
    elevationStyle: elevationStyleParam(config, prevElevation),
  };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_5: DocMigration = {
  maxSchemaVersion: "0.0.5",
  apply(json: any) {
    if (json.elevations && json.elevations.hasOwnProperty("defaultValue")) {
      const elevations = json.elevations.values;
      elevations[json.elevations.defaultValue].isDefault = true;
      json.elevations = elevations;
    }

    json.params = {
      ...json.params,
      ...elevationStyleParams(json.elevations, json.params?.["elevationStyle"]),
    };

    return json;
  },
};

export default migration_0_0_5;
